// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"e91d5aac","57":"ce2a0af1","252":"029d983f","327":"f2ec5845","399":"2c38d984","600":"3840bc1e","608":"7a2f39c7","713":"24e625d5","896":"1aa6687d","914":"b0c407bf"}[chunkId] + ".chunk.js";
};